import {createContext, useReducer} from 'react'

export const TripsContext = createContext()

export const tripsReducer = (state, action) => {  //state is a reliable previous state value, action is the object we passed into the dispatch function (type and payload)
    switch (action.type) {
        case 'SET_TRIPS':
            return {
                trips: action.payload
            }
        case 'CREATE_TRIP':
            return {
                workouts: [action.payload, ...state.trips]
            }
        case 'DELETE_TRIP':
            return {
                trips: state.trips.filter((t) => t._id !== action.payload._id)  //creates a new array that only contains items that pass the test
            }
        default:
            return state
    }
}

export const TripsContextProvider = ({ children }) => {  //children represents the app component that we wrapped in the index.js file in this case
    const [state, dispatch] = useReducer(tripsReducer, { //useReducer similar to use state, with a state value and a dispatch to update the state value. (in this case, initial value is the workouts object.)
        //whats different is the workoutsReducer function. if we want to update state object, we call a dispatch function. inside the dispatch funcion, we pass an object as an argument which has a type property, which describes in words the state changes we are making. 
        //the payload represents any data we need to make this change, eg an array of workout objects. 
        trips: null
    })

    
    
    return ( //...state is essentially state.workouts, just spreading whats in state. 
        <TripsContext.Provider value={{...state, dispatch}}>
            { children }
        </TripsContext.Provider>
    )
}